// import React from "react";
// import Card from "../../Assets/Contact.JPG";

// const Contactus = () => {
//   return (
//     <div className="w-full min-h-screen bg-[#F2EFEA] flex flex-col lg:flex-row items-center justify-center p-4 gap-8 ">
//       <div className="w-full lg:w-[400px] max-w-2xl">
//         <img
//           src={Card}
//           alt="Contact collaboration"
//           className="w-full h-auto rounded-lg shadow-lg"
//         />
//       </div>

//       <div className="w-full lg:w-1/2 max-w-2xl">
//         <div className="mb-8">
//           <h2
//             className="text-4xl italic mb-4"
//             style={{
//               fontFamily: "theimpressionist",
//             }}
//           >
//             Get in Touch
//           </h2>
//         </div>

//         <form
//           className="space-y-6  "
//           style={{
//             fontFamily: "Blacker Pro Display",
//           }}
//         >
//           <div className="flex flex-col md:flex-row gap-4">
//             <div className="flex-1">
//               <label className="block text-md font-meduim tracking-wider text-gray-700 mb-1 ">
//                 First Name
//               </label>
//               <input
//                 type="text"
//                 required
//                 className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-black"
//               />
//             </div>

//             <div className="flex-1">
//               <label className="block text-md font-medium tracking-wider text-gray-700 mb-1">
//                 Last Name
//               </label>
//               <input
//                 type="text"
//                 required
//                 className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-black"
//               />
//             </div>
//           </div>

//           <div>
//             <label className="block text-sm font-medium tracking-wider text-gray-700 mb-1">
//               Email
//             </label>
//             <input
//               type="email"
//               required
//               className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-black"
//             />
//           </div>

//           <div>
//             <label className="block text-sm font-medium tracking-wider text-gray-700 mb-1">
//               Subject
//             </label>
//             <input
//               type="text"
//               required
//               className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-black"
//             />
//           </div>

//           <div>
//             <label className="block text-sm font-medium tracking-wider text-gray-700 mb-1">
//               Message
//             </label>
//             <textarea
//               required
//               rows={4}
//               className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-black resize-none"
//             ></textarea>
//           </div>

//           <button
//             type="submit"
//             className="w-full bg-black text-white py-2 px-4 rounded-md hover:bg-gray-800 transition-colors duration-200"
//           >
//             Send Message
//           </button>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default Contactus;

import React, { useState } from "react";
import Card from "../../Assets/Contact.JPG";

const Contactus = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    subject: "",
    message: "",
  });
  const [status, setStatus] = useState({ type: "", message: "" });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ type: "info", message: "Sending..." });

    try {
      const response = await fetch(
        "https://connectengagegrow.shop/ceg/Backend/contact-form-handler.php",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
          credentials: "include", // If you need cookies for authentication
        }
      );

      const data = await response.json();

      if (response.ok) {
        setStatus({ type: "success", message: "Message sent successfully!" });
        setFormData({
          firstName: "",
          lastName: "",
          email: "",
          subject: "",
          message: "",
        });
      } else {
        setStatus({
          type: "error",
          message: data.error || "Failed to send message",
        });
      }
    } catch (error) {
      setStatus({ type: "error", message: "Failed to send message" });
    }
  };

  return (
    <div className="w-full min-h-screen bg-[#F2EFEA] flex flex-col lg:flex-row items-center justify-center p-4 gap-8">
      <div className="w-full lg:w-[400px] max-w-2xl">
        <img
          src={Card}
          alt="Contact collaboration"
          className="w-full h-auto rounded-lg shadow-lg"
        />
      </div>

      <div className="w-full lg:w-1/2 max-w-2xl">
        <div className="mb-8">
          <h2
            className="text-4xl italic mb-4"
            style={{
              fontFamily: "theimpressionist",
            }}
          >
            Get in Touch
          </h2>
        </div>

        {status.message && (
          <div
            className={`mb-4 p-4 rounded ${
              status.type === "success"
                ? "bg-green-100 text-green-700"
                : status.type === "error"
                ? "bg-red-100 text-red-700"
                : "bg-blue-100 text-blue-700"
            }`}
          >
            {status.message}
          </div>
        )}

        <form
          onSubmit={handleSubmit}
          className="space-y-6"
          style={{
            fontFamily: "Blacker Pro Display",
          }}
        >
          <div className="flex flex-col md:flex-row gap-4">
            <div className="flex-1">
              <label className="block text-md font-meduim tracking-wider text-gray-700 mb-1">
                First Name
              </label>
              <input
                type="text"
                name="firstName"
                value={formData.firstName}
                onChange={handleChange}
                required
                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-black"
              />
            </div>

            <div className="flex-1">
              <label className="block text-md font-medium tracking-wider text-gray-700 mb-1">
                Last Name
              </label>
              <input
                type="text"
                name="lastName"
                value={formData.lastName}
                onChange={handleChange}
                required
                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-black"
              />
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium tracking-wider text-gray-700 mb-1">
              Email
            </label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-black"
            />
          </div>

          <div>
            <label className="block text-sm font-medium tracking-wider text-gray-700 mb-1">
              Subject
            </label>
            <input
              type="text"
              name="subject"
              value={formData.subject}
              onChange={handleChange}
              required
              className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-black"
            />
          </div>

          <div>
            <label className="block text-sm font-medium tracking-wider text-gray-700 mb-1">
              Message
            </label>
            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              required
              rows={4}
              className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-black resize-none"
            ></textarea>
          </div>

          <button
            type="submit"
            className="w-full bg-black text-white py-2 px-4 rounded-md hover:bg-gray-800 transition-colors duration-200"
          >
            Send Message
          </button>
        </form>
      </div>
    </div>
  );
};

export default Contactus;
